import React from "react";
import styled from "styled-components";

const Wrap = styled.div`
  box-sizing: border-box;
  margin-top: 6em;
  height: 100%;
  display: flex;
  justify-content: center;
  background-color: #454545;
  border-top: 4em #cdcdcd solid;
`;

const FormWrapper = styled.div`
  margin-top: 3em;
  width: 100%;
  margin: 10%;
  @media only screen and (max-width: 800px) {
    margin: 10% 5%;
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  color: #171717;
  margin-bottom: 2em;
`;

const Row = styled.div`
  display: flex;
  width: 100%;
`;

const DoubleRow = styled(Row)`
  @media only screen and (max-width: 800px) {
    flex-direction: column;
  }
`;

const Title = styled.h1`
  text-align: center;
  color: #fafafa;
  text-transform: uppercase;
  margin-bottom: 2em;
  margin-top: 2em;
  font-family: "Oswald", sans-serif;
`;

const InputField = styled.input`
  background-color: #fefefe;
  height: 2.5em;
  padding: 0 0em;
  margin-right: 0.75em;
  font-size: 1em;
  line-height: 1;
  border: none;
  width: 100%;
  text-indent: 10px;
  @media only screen and (max-width: 800px) {
    margin-top: 0.75em;
  }
`;

const PhoneField = styled(InputField)`
  margin-right: 0;
  @media only screen and (max-width: 800px) {
    /* margin-top: 0.75em; */
  }
`;
const EmailField = styled(InputField)`
  margin-right: 0;
  margin-top: 0.75em;
  @media only screen and (max-width: 800px) {
  }
`;
const Textarea = styled.textarea`
  font-size: 1em;

  background-color: #fefefe;
  width: 100%;
  height: 6em;

  margin-top: 0.75em;
  text-indent: 10px;
  padding-top: 0.75em;
`;

const Button = styled.button`
  margin-top: 0.75em;
  border: none;
  text-decoration: none;
  background-color: #171717;
  box-shadow: 0 1px 3px hsla(0, 0%, 0%, 0.2);

  color: #fafafa;
  width: 25%;
  height: 3em;
  font-size: 1em;
  @media only screen and (max-width: 800px) {
    width: 100%;
  }
`;

function Contact() {
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [contact, setContact] = React.useState("");

  return (
    <Wrap>
      <FormWrapper>
        <Title>Ota yhteyttä</Title>
        <Form
          name="yhteydenotto"
          method="POST"
          netlify-honeypot="shii"
          data-netlify="true"
        >
          <input name="shii" type="hidden" />
          <DoubleRow>
            <InputField
              placeholder="Nimi"
              label="nimi"
              name="nimi"
              onChange={(e) => {
                e.preventDefault();
                setName(e.target.value);
              }}
              value={name}
            />
            <PhoneField
              placeholder="Puhelinnumero"
              type="tel"
              label="puhelinnumero"
              name="numero"
              value={phone}
              onChange={(e) => {
                e.preventDefault();
                setPhone(e.target.value);
              }}
            />
          </DoubleRow>
          <Row>
            <EmailField
              placeholder="Sähköposti"
              type="email"
              label="sähköposti"
              name="sähköposti"
              value={email}
              onChange={(e) => {
                e.preventDefault();
                setEmail(e.target.value);
              }}
            />
          </Row>
          <Row>
            <Textarea
              placeholder="Viesti..."
              label="viesti"
              name="viesti"
              value={contact}
              onChange={(e) => {
                e.preventDefault();
                setContact(e.target.value);
              }}
            />
          </Row>
          <Row>
            <Button
              type="submit"
              disabled={isDisabled(contact, email, phone, name)}
            >
              Lähetä
            </Button>
          </Row>
        </Form>
      </FormWrapper>
    </Wrap>
  );
}

function isDisabled(contact, email, phone, name) {
  if (contact.length < 10) {
    return true;
  }

  if (email.length < 5 && phone.length < 5) {
    return true;
  }

  if (name.length === 0) {
    return true;
  }

  return false;
}

export default Contact;



// WEBPACK FOOTER //
// ./src/Components/Contact.js